import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import STRINGS from "../../Constants/Strings";

export const EditComplianceModal = ({
  showComplianceEditModal,
  handleComplianceModalClose,
  applicant,
  handleComplianceSaveClick,
  indicateWhoArray = [],
  accountPurposeList = [],
}) => {
  const [complianceFormData, setComplianceFormData] = useState({
    memberJurisdiction: applicant?.regulatory?.memberJurisdiction || "",
    intendedUseOfMembership: applicant?.member?.intendedUseOfMembership || "",
    isThirdPartyAccount: !!(
      applicant?.thirdParties && applicant.thirdParties.length > 0
    ),
    thirdPartyName: applicant?.thirdParties?.[0]?.name || "",
    thirdPartyRelationship: applicant?.thirdParties?.[0]?.relationship || "",
    areYouPEPorHIO: !!(applicant?.peps && applicant.peps.length > 0),
    memberPEPDomestic: applicant?.regulatory?.memberIsPedp || false,
    memberPEPForeign: applicant?.regulatory?.memberIsPefp || false,
    memberHIO: applicant?.regulatory?.memberIsHio || false,
    memberOfficeHeld: applicant?.regulatory?.memberOfficeHeld || "",
    memberFundsSource: applicant?.regulatory?.memberFundsSource || "",
  });

  const [complianceFormErrors, setComplianceFormErrors] = useState({
    memberJurisdiction: "",
    thirdPartyName: "",
    thirdPartyRelationship: "",
    memberType: "",
    memberOfficeHeld: "",
    memberFundsSource: "",
  });

  useEffect(() => {
    setComplianceFormData({
      memberJurisdiction: applicant?.regulatory?.memberJurisdiction || "",
      intendedUseOfMembership: applicant?.member?.intendedUseOfMembership || "",
      isThirdPartyAccount: !!(
        applicant?.thirdParties && applicant.thirdParties.length > 0
      ),
      thirdPartyName: applicant?.thirdParties?.[0]?.name || "",
      thirdPartyRelationship: applicant?.thirdParties?.[0]?.relationship || "",
      areYouPEPorHIO: !!(applicant?.peps && applicant.peps.length > 0),
      memberPEPDomestic: applicant?.regulatory?.memberIsPedp || false,
      memberPEPForeign: applicant?.regulatory?.memberIsPefp || false,
      memberHIO: applicant?.regulatory?.memberIsHio || false,
      memberOfficeHeld: applicant?.regulatory?.memberOfficeHeld || "",
      memberFundsSource: applicant?.regulatory?.memberFundsSource || "",
    });
  }, [applicant]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setComplianceFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      const capitalizeFields = [
        "thirdPartyName",
        "memberJurisdiction",
        "memberFundsSource",
      ];

      let processedValue = value;
      if (capitalizeFields.includes(name)) {
        processedValue = value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        if (name === "thirdPartyName") {
          processedValue = processedValue.replace(
            /[^A-Za-zàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð\. \-'']/gi,
            ""
          );
        }
      }

      setComplianceFormData((prev) => ({
        ...prev,
        [name]: processedValue,
      }));
    }

    setComplianceFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleChoiceChange = (name, choice) => {
    setComplianceFormData((prev) => {
      const newData = { ...prev, [name]: choice };

      if (choice === false) {
        if (name === "isThirdPartyAccount") {
          newData.thirdPartyName = "";
          newData.thirdPartyRelationship = "";
        }
        if (name === "areYouPEPorHIO") {
          newData.memberPEPDomestic = false;
          newData.memberPEPForeign = false;
          newData.memberHIO = false;
          newData.memberOfficeHeld = "";
          newData.memberFundsSource = "";
        }
      }

      return newData;
    });

    if (name === "isThirdPartyAccount") {
      setComplianceFormErrors((prev) => ({
        ...prev,
        thirdPartyName: "",
        thirdPartyRelationship: "",
      }));
    }
    if (name === "areYouPEPorHIO") {
      setComplianceFormErrors((prev) => ({
        ...prev,
        memberType: "",
        memberOfficeHeld: "",
        memberFundsSource: "",
      }));
    }
  };

  const handlePEPTypeChange = (type) => {
    setComplianceFormData((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
    setComplianceFormErrors((prev) => ({
      ...prev,
      memberType: "",
    }));
  };

  const validateForm = () => {
    const errors = {
      memberJurisdiction: "",
      thirdPartyName: "",
      thirdPartyRelationship: "",
      memberType: "",
      memberOfficeHeld: "",
      memberFundsSource: "",
    };

    if (complianceFormData.isThirdPartyAccount) {
      if (!complianceFormData.thirdPartyName?.trim()) {
        errors.thirdPartyName =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_COMPLIANCE_DETAILS_MODAL.ERROR_THIRD_PARTY_NAME_REQUIRED;
      }
      if (!complianceFormData.thirdPartyRelationship?.trim()) {
        errors.thirdPartyRelationship =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_COMPLIANCE_DETAILS_MODAL.ERROR_RELATIONSHIP_REQUIRED;
      }
    }

    if (complianceFormData.areYouPEPorHIO) {
      if (
        !complianceFormData.memberPEPDomestic &&
        !complianceFormData.memberPEPForeign &&
        !complianceFormData.memberHIO
      ) {
        errors.memberType =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_COMPLIANCE_DETAILS_MODAL.ERROR_PEP_TYPE_REQUIRED;
      }
      if (!complianceFormData.memberOfficeHeld?.trim()) {
        errors.memberOfficeHeld =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_COMPLIANCE_DETAILS_MODAL.ERROR_OFFICE_HELD_REQUIRED;
      }
      if (!complianceFormData.memberJurisdiction?.trim()) {
        errors.memberJurisdiction =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_COMPLIANCE_DETAILS_MODAL.ERROR_JURISDICTION_REQUIRED;
      }
      if (!complianceFormData.memberFundsSource?.trim()) {
        errors.memberFundsSource =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_COMPLIANCE_DETAILS_MODAL.ERROR_FUNDS_SOURCE_REQUIRED;
      }
    }

    setComplianceFormErrors(errors);
    return !Object.values(errors).some((error) => error !== "");
  };

  const handleSave = () => {
    if (validateForm()) {
      handleComplianceSaveClick(complianceFormData);
      handleComplianceModalClose();
    }
  };

  return (
    <Modal
      show={showComplianceEditModal}
      onHide={handleComplianceModalClose}
      className="[ popup-modal__container ]"
      aria-labelledby="compliance-modal-title"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="[ popup-modal__header ]" closeButton>
        <Modal.Title id="compliance-modal-title">
          {
            STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
              .EDIT_COMPLIANCE_DETAILS_MODAL.TITLE
          }
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="[ row ]">
          <div className="[ col-12 ]">
            <div className="[ form-container ]">
              {/* Banking Relationship */}
              <div className="[ mb-3 ]">
                <label
                  htmlFor="intendedUseOfMembership"
                  className="[ form-label ]"
                >
                  {
                    STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                      .EDIT_COMPLIANCE_DETAILS_MODAL.BANKING_RELATIONSHIP_LABEL
                  }
                </label>
                <select
                  id="intendedUseOfMembership"
                  name="intendedUseOfMembership"
                  className="[ form-control ] [ select__dropdown ]"
                  value={complianceFormData.intendedUseOfMembership}
                  onChange={handleInputChange}
                >
                  <option value="">
                    {
                      STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_COMPLIANCE_DETAILS_MODAL.SELECT_OPTION
                    }
                  </option>
                  {(Array.isArray(accountPurposeList)
                    ? accountPurposeList
                    : []
                  ).map((obj) => (
                    <option key={obj.code} value={obj.code}>
                      {obj.description}
                    </option>
                  ))}
                </select>
              </div>

              {/* Third Party Account */}
              <div className="[ mb-3 ]">
                <div className="[ form-label ]">
                  {
                    STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                      .EDIT_COMPLIANCE_DETAILS_MODAL.THIRD_PARTY_LABEL
                  }
                </div>
                <div className="[ row ] [ custom-radios ]">
                  <div className="[ col-6 ]">
                    <button
                      type="button"
                      className={
                        complianceFormData.isThirdPartyAccount
                          ? "[ btn custom-radio-selected ]"
                          : "[ btn custom-radio-unselected ]"
                      }
                      onClick={() =>
                        handleChoiceChange("isThirdPartyAccount", true)
                      }
                    >
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.YES
                      }
                    </button>
                  </div>
                  <div className="[ col-6 ]">
                    <button
                      type="button"
                      className={
                        !complianceFormData.isThirdPartyAccount
                          ? "[ btn custom-radio-selected ]"
                          : "[ btn custom-radio-unselected ]"
                      }
                      onClick={() =>
                        handleChoiceChange("isThirdPartyAccount", false)
                      }
                    >
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.NO
                      }
                    </button>
                  </div>
                </div>
              </div>

              {complianceFormData.isThirdPartyAccount && (
                <div className="[ drawer-content-container ]">
                  <div className="[ info-title ]">
                    {
                      STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_COMPLIANCE_DETAILS_MODAL.THIRD_PARTY_INFO_TITLE
                    }
                  </div>
                  <div className="[ mb-3 ]">
                    <label htmlFor="thirdPartyName" className="[ form-label ]">
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.THIRD_PARTY_NAME_LABEL
                      }
                    </label>
                    <input
                      id="thirdPartyName"
                      type="text"
                      name="thirdPartyName"
                      className={`[ form-control ] ${
                        complianceFormErrors.thirdPartyName
                          ? "[ is-invalid ]"
                          : ""
                      }`}
                      value={complianceFormData.thirdPartyName}
                      onChange={handleInputChange}
                      placeholder={
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL
                          .THIRD_PARTY_NAME_PLACEHOLDER
                      }
                    />
                    {complianceFormErrors.thirdPartyName && (
                      <div className="[ invalid-feedback ] [ error-msg ]">
                        {complianceFormErrors.thirdPartyName}
                      </div>
                    )}
                  </div>

                  <div className="[ mb-3 ]">
                    <label
                      htmlFor="thirdPartyRelationship"
                      className="[ form-label ]"
                    >
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.RELATIONSHIP_LABEL
                      }
                    </label>
                    <select
                      id="thirdPartyRelationship"
                      name="thirdPartyRelationship"
                      className={`[ form-control ] [ select__dropdown ] ${
                        complianceFormErrors.thirdPartyRelationship
                          ? "[ is-invalid ]"
                          : ""
                      }`}
                      value={complianceFormData.thirdPartyRelationship}
                      onChange={handleInputChange}
                    >
                      <option value="">
                        {
                          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                            .EDIT_COMPLIANCE_DETAILS_MODAL.SELECT_OPTION
                        }
                      </option>
                      {(Array.isArray(indicateWhoArray)
                        ? indicateWhoArray
                        : []
                      ).map((obj) => (
                        <option key={obj.code} value={obj.description}>
                          {obj.description}
                        </option>
                      ))}
                    </select>
                    {complianceFormErrors.thirdPartyRelationship && (
                      <div className="[ invalid-feedback ] [ error-msg ]">
                        {complianceFormErrors.thirdPartyRelationship}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* PEP/HIO */}
              <div className="[ mb-3 ]">
                <div className="[ form-label ]">
                  {
                    STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                      .EDIT_COMPLIANCE_DETAILS_MODAL.PEP_HIO_LABEL
                  }
                </div>
                <div className="[ row ] [ custom-radios ]">
                  <div className="[ col-6 ]">
                    <button
                      type="button"
                      className={
                        complianceFormData.areYouPEPorHIO
                          ? "[ btn custom-radio-selected ]"
                          : "[ btn custom-radio-unselected ]"
                      }
                      onClick={() => handleChoiceChange("areYouPEPorHIO", true)}
                    >
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.YES
                      }
                    </button>
                  </div>
                  <div className="[ col-6 ]">
                    <button
                      type="button"
                      className={
                        !complianceFormData.areYouPEPorHIO
                          ? "[ btn custom-radio-selected ]"
                          : "[ btn custom-radio-unselected ]"
                      }
                      onClick={() =>
                        handleChoiceChange("areYouPEPorHIO", false)
                      }
                    >
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.NO
                      }
                    </button>
                  </div>
                </div>
              </div>

              {complianceFormData.areYouPEPorHIO && (
                <div className="[ drawer-content-container ]">
                  <div className="[ info-title ]">
                    {
                      STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_COMPLIANCE_DETAILS_MODAL.PEP_HIO_INFO_TITLE
                    }
                  </div>

                  <div className="[ mb-3 ]">
                    <div className="[ form-label ]">
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.PEP_TYPE_LABEL
                      }
                    </div>
                    <div className="[ row ] [ custom-radios ]">
                      <div className="[ col-4 ]">
                        <button
                          type="button"
                          className={
                            complianceFormData.memberPEPDomestic
                              ? "[ btn custom-radio-selected ] [ w-100 ]"
                              : "[ btn custom-radio-unselected ] [ w-100 ]"
                          }
                          onClick={() =>
                            handlePEPTypeChange("memberPEPDomestic")
                          }
                        >
                          {
                            STRINGS.BRANCH.MEMBER_PROFILE
                              .MEMBER_QUICK_VIEW_PANEL
                              .EDIT_COMPLIANCE_DETAILS_MODAL.PEP_DOMESTIC
                          }
                        </button>
                      </div>
                      <div className="[ col-4 ]">
                        <button
                          type="button"
                          className={
                            complianceFormData.memberPEPForeign
                              ? "[ btn custom-radio-selected ] [ w-100 ]"
                              : "[ btn custom-radio-unselected ] [ w-100 ]"
                          }
                          onClick={() =>
                            handlePEPTypeChange("memberPEPForeign")
                          }
                        >
                          {
                            STRINGS.BRANCH.MEMBER_PROFILE
                              .MEMBER_QUICK_VIEW_PANEL
                              .EDIT_COMPLIANCE_DETAILS_MODAL.PEP_FOREIGN
                          }
                        </button>
                      </div>
                      <div className="[ col-4 ]">
                        <button
                          type="button"
                          className={
                            complianceFormData.memberHIO
                              ? "[ btn custom-radio-selected ] [ w-100 ]"
                              : "[ btn custom-radio-unselected ] [ w-100 ]"
                          }
                          onClick={() => handlePEPTypeChange("memberHIO")}
                        >
                          {
                            STRINGS.BRANCH.MEMBER_PROFILE
                              .MEMBER_QUICK_VIEW_PANEL
                              .EDIT_COMPLIANCE_DETAILS_MODAL.HIO
                          }
                        </button>
                      </div>
                    </div>
                    {complianceFormErrors.memberType && (
                      <div className="[ invalid-feedback ] [ error-msg ]">
                        {complianceFormErrors.memberType}
                      </div>
                    )}
                  </div>

                  <div className="[ mb-3 ]">
                    <label
                      htmlFor="memberOfficeHeld"
                      className="[ form-label ]"
                    >
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.OFFICE_HELD_LABEL
                      }
                    </label>
                    <input
                      id="memberOfficeHeld"
                      type="text"
                      name="memberOfficeHeld"
                      className={`[ form-control ] ${
                        complianceFormErrors.memberOfficeHeld
                          ? "[ is-invalid ]"
                          : ""
                      }`}
                      value={complianceFormData.memberOfficeHeld}
                      onChange={handleInputChange}
                      placeholder={
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.OFFICE_HELD_PLACEHOLDER
                      }
                    />
                    {complianceFormErrors.memberOfficeHeld && (
                      <div className="[ invalid-feedback ] [ error-msg ]">
                        {complianceFormErrors.memberOfficeHeld}
                      </div>
                    )}
                  </div>

                  <div className="[ mb-3 ]">
                    <label
                      htmlFor="memberJurisdiction"
                      className="[ form-label ]"
                    >
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.JURISDICTION_LABEL
                      }
                    </label>
                    <input
                      id="memberJurisdiction"
                      type="text"
                      name="memberJurisdiction"
                      className={`[ form-control ] ${
                        complianceFormErrors.memberJurisdiction
                          ? "[ is-invalid ]"
                          : ""
                      }`}
                      value={complianceFormData.memberJurisdiction}
                      onChange={handleInputChange}
                      placeholder={
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL
                          .JURISDICTION_PLACEHOLDER
                      }
                    />
                    {complianceFormErrors.memberJurisdiction && (
                      <div className="[ invalid-feedback ] [ error-msg ]">
                        {complianceFormErrors.memberJurisdiction}
                      </div>
                    )}
                  </div>

                  <div className="[ mb-3 ]">
                    <label
                      htmlFor="memberFundsSource"
                      className="[ form-label ]"
                    >
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL.FUNDS_SOURCE_LABEL
                      }
                    </label>
                    <input
                      id="memberFundsSource"
                      type="text"
                      name="memberFundsSource"
                      className={`[ form-control ] ${
                        complianceFormErrors.memberFundsSource
                          ? "[ is-invalid ]"
                          : ""
                      }`}
                      value={complianceFormData.memberFundsSource}
                      onChange={handleInputChange}
                      placeholder={
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_COMPLIANCE_DETAILS_MODAL
                          .FUNDS_SOURCE_PLACEHOLDER
                      }
                      maxLength={40}
                    />
                    {complianceFormErrors.memberFundsSource && (
                      <div className="[ invalid-feedback ] [ error-msg ]">
                        {complianceFormErrors.memberFundsSource}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="[ divider ]"></div>
      </Modal.Body>

      <Modal.Footer className="[ popup-modal-footer ] [ d-block ]">
        <div className="[ mb-3 ]">
          <button
            type="button"
            className="[ submit-btn btn ] [ w-100 ]"
            onClick={handleSave}
            style={{ borderRadius: ".5em" }}
          >
            {
              STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                .EDIT_COMPLIANCE_DETAILS_MODAL.SAVE_BUTTON
            }
          </button>
        </div>
        <div className="[ mb-3 text-center ]">
          <span
            className="[ link ]"
            onClick={handleComplianceModalClose}
            role="presentation"
            style={{
              textDecoration: "underline",
              color: "#0090c6",
              cursor: "pointer",
            }}
          >
            {
              STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                .EDIT_COMPLIANCE_DETAILS_MODAL.CANCEL_BUTTON
            }
          </span>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
